import { Routes } from '@angular/router';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { AUTH_REDIRECT_ROUTE } from '@shared/constants/fields.constants';

export const demandRequirementsRoutes: Routes = [
    {
        path: 'demand-requirements/window-submission-extensions',
        loadComponent: () =>
            import('./window-submission-extensions/window-submission-extensions-list/window-submission-extensions-list.component').then((c) => c.WindowSubmissionExtensionsListComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
            permissions: {
                only: ['ROLE_VIEW_DEMAND_CYCLE'],
                redirectTo: AUTH_REDIRECT_ROUTE,
            },
        },
    },
    {
        path: 'demand-requirements/window-submission-extensions/:uuid',
        loadComponent: () =>
            import('./window-submission-extensions/window-submission-extension-detail/window-submission-extension-detail.component').then((c) => c.WindowSubmissionExtensionDetailComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
            permissions: {
                only: ['ROLE_VIEW_DEMAND_CYCLE'],
                redirectTo: AUTH_REDIRECT_ROUTE,
            },
        },
    },
    {
        path: 'demand-requirements/ports',
        loadComponent: () =>
            import('./ports/ports.component').then((c) => c.PortsComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
            permissions: {
                only: ['ROLE_VIEW_PORT'],
                redirectTo: AUTH_REDIRECT_ROUTE,
            },
        },
    },
    {
        path: 'demand-requirements/demand-cycles',
        loadComponent: () =>
            import('./demand-cycles/demand-cycles.component').then((c) => c.DemandCyclesComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
            permissions: {
                only: ['ROLE_VIEW_DEMAND_CYCLE'],
                redirectTo: AUTH_REDIRECT_ROUTE,
            },
        },
    },
    {
        path: 'demand-requirements/demand-cycles/new',
        loadComponent: () =>
            import('./demand-cycles/demand-cycle-form.component').then((c) => c.DemandCycleFormComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
            permissions: {
                only: ['ROLE_CREATE_DEMAND_CYCLE'],
                redirectTo: AUTH_REDIRECT_ROUTE,
            },
        },
    },
    {
        path: 'demand-requirements/demand-cycles/:uuid/edit',
        loadComponent: () =>
            import('./demand-cycles/demand-cycle-form.component').then((c) => c.DemandCycleFormComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
            permissions: {
                only: ['ROLE_UPDATE_DEMAND_CYCLE'],
                redirectTo: AUTH_REDIRECT_ROUTE,
            },
        },
    },
    {
        path: 'demand-requirements/demand-cycles/:uuid/submissions-summary',
        loadComponent: () =>
            import('./demand-cycles/demand-cycle-submissions-summary.component').then((c) => c.DemandCycleSubmissionsSummaryComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
            permissions: {
                only: ['ROLE_MANAGE_OMC_DEMAND_CARGO', 'ROLE_VIEW_OMC_DEMAND'],
                redirectTo: AUTH_REDIRECT_ROUTE,
            },
        },
    },
    {
        path: 'demand-requirements/demand-cycles/:uuid',
        loadComponent: () =>
            import('./demand-cycles/demand-cycle-detail.component').then((c) => c.DemandCycleDetailComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
            permissions: {
                only: ['ROLE_VIEW_DEMAND_CYCLE'],
                redirectTo: AUTH_REDIRECT_ROUTE,
            },
        },
    },
    {
        path: 'demand-requirements/omc-demand-submissions',
        loadComponent: () =>
            import('./omc-demand-submissions/omc-demand-submissions.component').then((c) => c.OmcDemandSubmissionsComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
            title: 'OMC Demand Submissions',
            description: 'Review draft, waiting for action, and approved OMC demand submissions.',
            permissions: {
                only: ['ROLE_VIEW_OMC_DEMAND'],
                redirectTo: AUTH_REDIRECT_ROUTE,
            },
        },
    },
    {
        path: 'demand-requirements/omc-demand-submissions/draft',
        loadComponent: () =>
            import('./omc-demand-submissions/omc-demand-submissions.component').then((c) => c.OmcDemandSubmissionsComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
            initialFilterKey: 'draft',
            permissions: {
                only: ['ROLE_VIEW_OMC_DEMAND'],
                redirectTo: AUTH_REDIRECT_ROUTE,
            },
        },
    },
    {
        path: 'demand-requirements/omc-demand-submissions/submitted',
        loadComponent: () =>
            import('./omc-demand-submissions/omc-demand-submissions.component').then((c) => c.OmcDemandSubmissionsComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
            initialFilterKey: 'submitted',
            permissions: {
                only: ['ROLE_VIEW_OMC_DEMAND'],
                redirectTo: AUTH_REDIRECT_ROUTE,
            },
        },
    },
    {
        path: 'demand-requirements/omc-demand-submissions/approved',
        loadComponent: () =>
            import('./omc-demand-submissions/omc-demand-submissions.component').then((c) => c.OmcDemandSubmissionsComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
            initialFilterKey: 'approved',
            permissions: {
                only: ['ROLE_VIEW_OMC_DEMAND'],
                redirectTo: AUTH_REDIRECT_ROUTE,
            },
        },
    },
    {
        path: 'demand-requirements/omc-demand-submissions/:id/cargo-management',
        loadComponent: () =>
            import('./omc-demand-submissions/cargo-management/omc-demand-cargo-management.component').then((c) => c.OmcDemandCargoManagementComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
            permissions: {
                only: ['ROLE_MANAGE_OMC_DEMAND_CARGO'],
                redirectTo: AUTH_REDIRECT_ROUTE,
            },
        },
    },
    {
        path: 'demand-requirements/omc-demand-submissions/:id',
        loadComponent: () =>
            import('./omc-demand-submissions/omc-demand-submission-details/omc-demand-submission-details.component').then((c) => c.OmcDemandSubmissionDetailsComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
            permissions: {
                only: ['ROLE_VIEW_OMC_DEMAND'],
                redirectTo: AUTH_REDIRECT_ROUTE,
            },
        },
    },
];
